import { Route, Switch } from 'react-router-dom'

import { Page as List } from './list/page'
import { Page as Management } from './management/page'

export const UserGroups = ({ match }) => (
  <Switch>
    <Route path={`${match.url}`} exact component={List} />
    <Route path={`${match.url}/:id`} component={Management} />
  </Switch>
)
